import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import useIntersectionObserver from '../../../Hooks/useIntersectionObserver';
import useStatsQuery from '../../../Hooks/useStatsQuery';

const convertDateRangeToISOString = (dateRange: any) => {
  const from = new Date(dateRange[0]);
  const to = new Date(dateRange[1]);

  const fromDate = new Date(from);
  fromDate.setUTCHours(0, 0, 0, 0);

  const toDate = new Date(to);
  toDate.setUTCHours(23, 59, 59, 999);

  return [fromDate.toISOString(), toDate.toISOString()];
};

function WrapperStatsQuery({
  statsSlug,
  i18nKeyForSubtitle,
  children,
  defaultInterval,
  from,
  enableDateRange,
  dateRangeProps,
  ...props
}: any) {
  const intl = useIntl();
  const myRef = useRef<HTMLElement>(null);
  const isSectionVisible = useIntersectionObserver(myRef);
  const [interval, setInterval] = useState(defaultInterval);
  const [dateRange, setDateRange] = React.useState([
    from || new Date().setMonth(new Date().getMonth() - 3),
    new Date(),
  ]);
  const [fromDateTime, toDateTime] = convertDateRangeToISOString(dateRange);

  const { data, isFetching } = useStatsQuery(
    statsSlug,
    {
      statsSlug,
      interval,
      from: enableDateRange ? fromDateTime : undefined,
      to: enableDateRange ? toDateTime : undefined,
      ...props,
    },
    {
      enabled: isSectionVisible,
    },
  );

  return (
    <section ref={myRef}>
      {React.cloneElement(children, {
        data,
        loading: isFetching,
        setInterval,
        interval,
        enableDateRange,
        dateRangeProps: {
          dateRange,
          setDateRange,
          ...dateRangeProps,
        },
        subtitle: i18nKeyForSubtitle
          ? intl.formatMessage({ id: i18nKeyForSubtitle }, { count: data?.count || 0 })
          : undefined,
      })}
    </section>
  );
}

export default WrapperStatsQuery;
